import { Server, Code2, LayoutDashboard, CalendarSync, Smartphone, Globe, Layout, Zap, Package } from 'lucide-react';

const icons = {
  server: Server,
  code: Code2,
  dashboard: LayoutDashboard,
  calendar: CalendarSync,
  smartphone: Smartphone,
  globe: Globe,
  layout: Layout,
  zap: Zap
};

const ProjectIcon = ({ name, size = 22 }) => {
  const Icon = icons[name] || Package;
  return <Icon size={size} />;
};

export default ProjectIcon;
